const preType = 'COMMENTS_';

export const CommentsActionTypes = {
  GET_COMMENTS_LIST: `${preType}GET_COMMENTS_LIST`,
  SET_COMMENTS_LIST: `${preType}SET_COMMENTS_LIST`,
  GET_EXTENDED_COMMENTS_LIST: `${preType}GET_EXTENDED_COMMENTS_LIST`,
  SET_INITIAL_STATE: `${preType}SET_INITIAL_STATE`,
};

const getCommentsList = () => ({ type: CommentsActionTypes.GET_COMMENTS_LIST });
const getExtendedCommentsList = () => ({ type: CommentsActionTypes.GET_EXTENDED_COMMENTS_LIST });
const setInitialState = () => ({ type: CommentsActionTypes.SET_INITIAL_STATE });

export const CommentsActions = {
  getCommentsList: getCommentsList,
  getExtendedCommentsList: getExtendedCommentsList,
  setInitialState: setInitialState,
};

